'use client'

import React, { useState } from "react";
import styles from "./ArtContactSectionSplit.module.scss";
import { useAOS } from "@/src/lib/hooks/useAOS";

interface ArtContactSectionSplitProps {
    title: string;
    description: string;
    phone: string;
    email: string;
    image: string;
    successMessage: string;
}

const ArtContactSectionSplit: React.FC<ArtContactSectionSplitProps> = ({
    title,
    description,
    phone,
    email,
    image,
    successMessage
}) => {
    useAOS();
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const form = e.currentTarget;

        const data = {
            name: (form.elements.namedItem("name") as HTMLInputElement).value,
            email: (form.elements.namedItem("email") as HTMLInputElement).value,
            subject: (form.elements.namedItem("subject") as HTMLInputElement).value,
            message: (form.elements.namedItem("message") as HTMLTextAreaElement).value,
        };

        await fetch("/api/contact", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
        });

        form.reset();
        setSuccess(true);

        setTimeout(() => setSuccess(false), 4000);
    };

    return (
        <section className={styles.section}>
            {/* LEFT IMAGE */}
            <div
                className={styles.image}
                style={{ backgroundImage: `url(${image})` }}
                data-aos="fade-right"
            />

            {/* RIGHT SIDE */}
            <div className={styles.content} data-aos="fade-left">
                <div className={styles.inner}>
                    <h2 className={styles.title}>{title}</h2>


                    <p className={styles.description}>{description}</p>

                    <div className={styles.info}>
                        <p>{phone}</p>
                        <p>{email}</p>
                    </div>

                    <form onSubmit={handleSubmit} className={styles.form}>
                        <input name="name" placeholder="Nom" required />
                        <input type="email" name="email" placeholder="Email" required />
                        <input name="subject" placeholder="Sujet" required />
                        <textarea name="message" placeholder="Message" rows={4} required />

                        <button type="submit">Envoyer</button>
                    </form>

                    {success && <span className={styles.success}>{successMessage}</span>}
                </div>
            </div>
        </section>
    );
};

export default ArtContactSectionSplit;
